import * as angular from 'angular';
import { map, SeriesFormat } from '../../../charting/charts/DoughnutChart';
import { SvgManager, Margins, ICategoricalChartOptions } from '../../..';
import { IDynamicCompileService } from '../../services/dynamicCompileService';
import { HorizontalCategoricalChart } from '../../../charting/charts/HorizontalCategoricalChart/HorizontalCategoricalChart';

class HorizontalCategoricalChartController implements angular.IComponentController,
    angular.IOnInit,
    angular.IOnChanges {
    series: SeriesFormat[];
    data: any[];
    options: ICategoricalChartOptions;
    componentId: string;
    private _chart: HorizontalCategoricalChart;

    static $inject = ['$scope', '$element', 'dynamicCompileService'];
    constructor(private _$scope: angular.IScope,
        private _$element: angular.IAugmentedJQuery,
        private _dynamicCompileService: IDynamicCompileService) {
    }

    $onInit(): void {
        const id = this.componentId;
        if (!id) {
            console.error('Cannot use horizontal categorical chart. An id is required.');
        } else {
            this._$element.attr('id', id);
            // select the div below custom element
            const svgManager = new SvgManager(id + ' div.horizontal-categorical-chart-container', new Margins(0, 0, 0, 0));
            this._chart = new HorizontalCategoricalChart(svgManager);
            this.update();
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        this.update();
        if (changesObj['series'] && this.series && this.series.filter(s => !!s.attributes).length) {
            this._dynamicCompileService.compileGroup(this._$element, this._$scope as any, null, this.series);
        }
    }

    private update() {
        if (this.series && this.data && this.options && this._chart) {
            const mapped = map(this.series, this.data, this.options);
            this._chart
                .options(this.options)
                .update(mapped);
        }
    }
}

export const wtHorizontalCategoricalChart: angular.IComponentOptions & { componentId: string } = {
    componentId: 'wtHorizontalCategoricalChart',
    controller: HorizontalCategoricalChartController,
    template: '<div class="full-size horizontal-categorical-chart-container"><svg></svg></div>',
    // template: require('./doughnutChart.component.html'),
    controllerAs: 'vm',
    bindings: {
        series: '<',
        data: '<',
        options: '<',
        componentId: '@'
    }
};
